import axios from "axios";
import ConstantList from "../appConfig";
import HttpService from "./HttpService";
const API_PATH = ConstantList.API_EN_POINT + "/patient";
const API_PATH_2 = ConstantList.API_EN_POINT + "/document-holder";
const API_PATH_IDEN = ConstantList.API_EN_POINT + "/invoice-patient-iden";

export const pagingPatientByTab = (searchObject) =>
  axios.post(API_PATH + "/paging-patient-by-tab", searchObject);

export const pagingPatient = (searchObject) =>
  axios.post(API_PATH + "/paging-patient-role", searchObject);

export const pagingStatisticsPatient = (searchObject) =>
  axios.post(API_PATH + "/paging-statistics-patient", searchObject);

export const savePatient = (patient) =>
  axios.post(API_PATH + "/save-patient", patient);

// export const deletePatient = patientId => axios.delete(API_PATH + '/void-patient/' + patientId);

export const getPatient = (patientId) => axios.get(API_PATH + "/" + patientId);

export const savePatientExamReg = (patientExamReg) =>
  axios.post(API_PATH + "/save-patient-exam-reg", patientExamReg);

export const saveGeneralityPatientExamReg = (patientExamReg) =>
  axios.post(API_PATH + "/save-patient-generality-exam-reg", patientExamReg);

export const deletePatient = (patientId) =>
  axios.get(API_PATH + "/mark-delete/" + patientId);

export const getEhPatientByPatientId = (patientId) =>
  axios.get(API_PATH + "/eh-patient/" + patientId);

export const getPatientDashboard = (patientId) =>
  axios.get(API_PATH + "/get-patient-dashboard/" + patientId);

// export const getRecentVisit = patientId => axios.get(API_PATH + "/get-recent-visit/" + patientId);
//QR code
export const linkGenerateQrPatient = (patientCode) =>
  axios.get(API_PATH + "/generate-qr-code/" + patientCode, {
    responseType: "arraybuffer",
  });
//Barcode
export const linkGenerateBarcodePatient = (patientCode) =>
  axios.get(API_PATH + "/generate-barcode/" + patientCode, {
    responseType: "arraybuffer",
  });
export const linkGenerateQrByValue = (value) =>
  axios.post(API_PATH + "/get-qr-code-by-value", value, {
    responseType: "arraybuffer",
  });

export const getListEhImgByPatient = (patientId) =>
  axios.get(API_PATH + "/get-list-image-study-by-patient/" + patientId);
export const getListInvoiceByPatientId = (patientId) =>
  axios.get(API_PATH + "/get-list-invoice-by-patient/" + patientId);

export const checkDuplicatePatient = (patient) =>
  axios.post(API_PATH + "/check-duplicate-patient", patient);

export const getInitPatientByQRCode = (patient) =>
  axios.post(API_PATH + "/get-init-patient-by-qrcode", patient);

export const getVisitByQRCode = (patient) =>
  axios.post(API_PATH + "/get-visit-by-qr-code", patient);

export const getHICostStatement = (patient) =>
  axios.post(API_PATH + "/get-health-insurance-cost-statement", patient);

export const getBankInfoFromVietQR = () =>
  axios.get("https://api.vietqr.io/v2/banks");
export const getPatientByCode = (code) =>
  axios.get(API_PATH + "/get-patient-by-code/" + code);
export const getPatientByPhoneNumber = (number) =>
  axios.get(API_PATH + "/get-patient-by-phone-number/" + number);
export const getHealthInsuranceClassification = (code) =>
  axios.get(API_PATH + "/get-health-insurance-classification/" + code);

export const getVisitHistoryHealthInsurance = (dto) =>
  axios.post(API_PATH + "/get-visit-history-health-insurance", dto);

export const genBHYTforChildNoBirthCertificate = (dto) =>
  axios.post(API_PATH + "/gen-bhyt-for-child-no-birth-certificate", dto);

//
export const saveDocumentReceipt = (dto) =>
  axios.post(API_PATH_2 + "/save-or-update", dto);

// xet nghiem
export const getSpecifyResultLabtests = (id) =>
  axios.post(
    ConstantList.API_EN_POINT + "/lab-test/get-specify-result-labtest",
    {
      patientId: id,
    }
  );
export const getSpecifyResultImage = (id) =>
  axios.post(
    ConstantList.API_EN_POINT + "/img-study/get-specify-result-image",
    {
      patientId: id,
    }
  );

export const checkMismatchedInfoPatient = (patientInfoSearchDto) =>
  axios.post(API_PATH + "/check-mismatched-info-patient", patientInfoSearchDto);

export const getInfoFromIdentifier = (patient) =>
  axios.post(API_PATH + "/get-info-from-identifier", patient);

export const getMediHistory = (patient) =>
  axios.post(API_PATH + "/get-medication-by-patient", patient);

export const pagingInpatientEpisode = (searchObject) =>
  axios.post(API_PATH + "/paging-inpatient-episode", searchObject);

export const pagingAllergyMedicalHistory = (searchObject) =>
  axios.post(API_PATH + "/get-list-allergy-medical-history", searchObject);

export const getMedicalHistory = (id) =>
  axios.get(API_PATH + "/get-medical-history/" + id);

export const getPatientInfo = (patientId) =>
  axios.get(API_PATH + "/get-patient-info/" + patientId);

export const genInvoiceItemsByPatientIdentification = (searchObject) =>
  axios.post(API_PATH_IDEN + "/set-invoice-by-applicable-object", searchObject);

export const getInvoiceItemByDate = (obj) =>
  axios.post(API_PATH_IDEN + "/get-invoice-item-exp-date", obj);

export const updateInvoteChagePatientType = (obj) =>
  axios.post(API_PATH_IDEN + "/update-invoice-change-patient-type", obj);

export const getUpdateInvoiceItemWithPiden = (obj) =>
  axios.post(API_PATH_IDEN + "/get-update-invoice-item-with-piden", obj);
export const updateListInvoicePriceTypeAndDeletePIden = (obj) =>
  axios.post(API_PATH_IDEN + "/update-invoice-and-delete-patient-iden", obj);

export const cancelVisitOfPatient = (searchObject) =>
  axios.post(API_PATH + "/cancel-treatment-of-patient", searchObject);

export const pagingOutPatient = (searchObject) =>
  axios.post(API_PATH + "/paging-patient-manager", searchObject);

export const getPatientSeries = (searchObject) =>
  axios.post(API_PATH + "/get-patient-series", searchObject);

export const sentNotiBySMS = (obj) =>
  axios.post(ConstantList.API_EN_POINT + "/message/sms", obj);

export const sentNotiByZalo = (obj) =>
  axios.post(ConstantList.API_EN_POINT + "/message/zalo-sms", obj);

export const updateUseInsByListItem = (obj) =>
  axios.post(API_PATH_IDEN + "/update-use-ins-by-list-item", obj);

export const voidedPatient = (id) =>
  axios.delete(API_PATH + "/voided-patient/" + id);

export const getListPatientRequest = (searchObject) =>
  axios.post(API_PATH + "/get-list-patient-request", searchObject);

// LA
export const createPatient = (patient) =>
  axios.post(API_PATH + "/create-update-patient-crm", patient);

export const getPatientOverviewById = (patientId) =>
  axios.get(API_PATH + `/get-patient-overview/${patientId}`);

export const getPatientOverviewByIdNotLoading = (patientId) =>
  HttpService.getAxiosClient().get(
    API_PATH + `/get-patient-overview/${patientId}`
  );

export const getAllServicesOfPatientById = (patientId) =>
  axios.get(API_PATH + `/all-services/${patientId}`);

export const getAllSeriessPatient = (obj) =>
  HttpService.getAxiosClient().post(API_PATH + `/get-all-series-patient`, obj);

export const getDuplicatePhoneNumber = (obj) =>
  axios.post(API_PATH + `/get-duplicate-phone-number`, obj);

export const getPatientByPhone = (phoneNum) =>
  axios.get(API_PATH + `/get-patient-by-phone/${phoneNum}`);

export const saveMainPhoneNumForListPatient = (obj) =>
  axios.post(API_PATH + `/save-main-phone-num-for-list-patient`, obj);

export const exportExcelPatientList = (obj) => {
  let url = API_PATH + "/export-excel-patient-list";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
};

export const pagingPatientByNumberPhone = (numberPhone) =>
  axios.post(API_PATH + "/search-by-phone-number", numberPhone);

export const pagingPatientSync = (searchObject) =>
  axios.post(API_PATH + "/paging-patient-sync", searchObject);

export const mergePatient = (searchObject) =>
  axios.put(
    API_PATH + `/merge-patient/${searchObject?.newId}/${searchObject?.oldId}`,
    searchObject
  );

export const mergePatientHisToCrm = (searchObject) =>
  axios.put(
    API_PATH +
      `/merge-patient/${searchObject?.newId}/${searchObject?.oldId}/true`,
    searchObject
  );
